import React, { FC, MouseEvent, useCallback } from "react";
import TooltipValue from "./TooltipValue";
import { notification, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

type Props = {
  label: string;
  value?: string;
  copyable?: boolean;
};

const FullWidthLine: FC<Props> = ({ label, value, copyable = false }) => {
  const { t } = useTranslation("overview");

  const copyValueToClipboard = useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();
      // The component renders nothing when `value` is falsy, so the copy icon
      // this is wired to cannot be clicked without a value.
      navigator.clipboard.writeText(value!);

      notification.success({
        title: t("columnCells.customCell.copiedToClipboard"),
      });
    },
    [value, t],
  );

  if (!value) {
    return null;
  }

  return (
    <div className="full-width-line">
      <h5 className="label">{label}</h5>
      <div className="value-container">
        <TooltipValue value={value} />
        {copyable && (
          <Tooltip
            placement="topLeft"
            title={t("columnCells.customCell.copyTooltip")}
          >
            <i
              className="bi bi-copy copy-icon"
              onClick={copyValueToClipboard}
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default FullWidthLine;
